import React, { Component } from "react";
import { Row, Col, Form, ButtonGroup, Button } from "react-bootstrap";
import SalesforceFilters from './SalesforceFilters';
import { DateRangeCalendar } from "./DatePicker";
import moment from "moment";
import Auth from "../../Auth/Auth";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./AdvancedFiltering.scss";
const auth = new Auth();

function autocomplete(inp, arr, self) {
    /*the autocomplete function takes two arguments,
    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function (e) {
        var a, b, i, val = this.value;
        /*close any already open lists of autocompleted values*/
        closeAllLists();
        if (!val) { return false; }
        /*create a DIV element that will contain the items (values):*/
        a = document.createElement("DIV");
        a.setAttribute("id", this.id + "autocomplete-list");
        a.setAttribute("class", "autocomplete-items");
        /*append the DIV element as a child of the autocomplete container:*/
        this.parentNode.appendChild(a);
        /*for each item in the array...*/
        for (i = 0; i < arr.length; i++) {
            /*check if the item starts with the same letters as the text field value:*/
            if (arr[i].substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                /*create a DIV element for each matching element:*/
                b = document.createElement("DIV");
                /*make the matching letters bold:*/
                b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
                b.innerHTML += arr[i].substr(val.length);
                /*insert a input field that will hold the current array item"s value:*/
                b.innerHTML += `<input type="hidden" value="" + arr[i] + "">`;
                /*execute a function when someone clicks on the item value (DIV element):*/
                b.addEventListener("click", function (e) {
                    self.setState({
                        Namespace: this.getElementsByTagName("input")[0].value
                    })
                    /*insert the value for the autocomplete text field:*/
                    inp.value = this.getElementsByTagName("input")[0].value;
                    /*close the list of autocompleted values,
                    (or any other open lists of autocompleted values:*/
                    closeAllLists();
                });
                a.appendChild(b);
            }
        }
    });

    function closeAllLists(elmnt) {
        /*close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName("autocomplete-items");
        for (var i = 0; i < x.length; i++) {
            if (elmnt !== x[i] && elmnt !== inp) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
}

export default class AdvancedFiltering extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterError: "",
            Sources: ['D365', 'TFS', 'Jira'],

            Area: ["Dayforce Support", "Employee Support", "Tax Services", "Payroll Support", "Application Support", "Benefits Support", "Email", "Legacy Payroll Support"],
            SubArea: ["Benefit Support", "Payroll Processing", "Other Payroll Inquiries", "Wage Attachments", "Time & Attendance", "Enrollments", "Self Service"],
            Status: [{ "name": "Resolved", "value": "Problem Solved,Information Provided,Done,Committed,Completed,Already Exists,Shipped" },
            { "name": "In Progress", "value": "Active,On Hold,In Progress In Progress,In Progress,Waiting for Customer,Waiting for Ceridian,On Hold,Researching,Merged,Ideas,To Do,N/A,Approved,Design,In Progress,Evaluating theRequest. Vote to Support it.,Reviewed - Likely to implement.,Intend to Build - Release Date Pending,Reviewed - Request for more information,Needs review,Reviewed - Unlikely to implement." },
            { "name": "Cancelled", "value": "Canceled,Removed,Closed,Will Not Implement,Duplicate of an idea on the Client ideas portal" }],
            Severity: [{ "name": "4 - Low", "value": "4 - Low,4  Low" },
            { "name": "3 - Medium", "value": "3 - Medium,3  Medium" },
            { "name": "2 - High", "value": "2 - High,2  High" },
            { "name": "1 - Urgent", "value": "1 - Urgent,1  Critical" },
            { "name": "0 - Urgent GO LIVE", "value": "0 - Urgent GO LIVE" },
            { "name": "N/A", "value": "N/A" }],

            //TFS
            WorkItemType: ["Bug", "Task", "Test Suite", "Issue", "Backlog"],
            TFSSeverity: ["4- Low", "3 - Medium", "2 - High", "1 - Critical", "N/A"],
            TFSStatus: ["Approved", "Committed", "Design", "In Progress", "New", "QA Active", "Ready", "Ready QA", "Removed", "To Do"],
            AllTFSStatus: ["Any", "Accepted", "Active", "Added to Backlog", "Already Exists", "Approved", "Clarification", "Closed", "Completed", "Created", "Design", "Done", "Feature Implemented", "In Planning", "In Progress", "Inactive", "New", "On Hold", "Open", "QA Active", "Ready", "Ready QA", "Rejected", "Removed", "Requested", "Resolved", "To Do", "Verify", "Waiting Review"],

            Dates: [],
            PodTeam: [],
            Customer: "",
            ResolvedBy: "",
            OwnerFullName: "",
            selectedFilterArr: [],
            Namespaces: [],
            sourceChosen: [],
            showDateFilter: false,
            sortByDate: false,
            dateFilter: null,
            ResolveddateFilter: null,
            Source: [],

            //Salesforce
            SFStatuses: ["Complete", "New", "In Progress", "Waiting for Ceridian", "Closed", "Escalated", "Assigned"],
            SFSeverity: ["Sev 1", "Sev 2", "Sev 3", "Sev 4"],

            //Jira
            IssueType: ["Bug", "Story"],
            JiraSeverity: ["Sev-0", "Sev-1", "Sev-2", "Sev-3", "Sev-4"],
            JiraStatus: []
        };
    }

    componentDidMount() {
        setTimeout(function () {
            if (sessionStorage.getItem("LastFilters") && sessionStorage.getItem("LastFilters") !== null) {
                let json = JSON.parse(sessionStorage.getItem("LastFilters"));
                let checkboxes = document.getElementsByClassName("custom-control-input");
                for (let i = 0; i < Object.keys(json).length; i++) {
                    // let objName = Object.keys(json)[i];
                    let objVal = Object.values(json)[i];
                    for (var val = 0; val < objVal.length; val++) {
                        for (var j = 0; j < checkboxes.length; j++) {
                            if (checkboxes[j].value === objVal[val]) {
                                checkboxes[j].checked = true;
                            }
                        }
                    }
                }
            }
        }, 500);
        this.getJiraStatusFilters();
        this.setState({
            Namespaces: this.props.Namespaces
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.Namespaces !== this.props.Namespaces) {
            this.setState({
                Namespaces: this.props.Namespaces
            });
        }
    }

    async getJiraStatusFilters() {
        let accessToken = await auth.getToken();
        fetch('/api/getJiraStatusFilters', {
            method: "GET",
            headers: {
                'Authorization': "Bearer " + accessToken,
                withCredentials: true,
                crossDomain: true
            }
        }).then(response => {
            if (response.status !== 200) {
                let payload = [{
                    status: response.status,
                    rawmsg: response.statusText,
                    cleanmsg: response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp: Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return response.json();
        }).then(data => {
            if (data[0] && data[0].length > 0) {
                let jiraStatus = [];
                data[0].forEach(element => {
                    jiraStatus.push(element.status.trim());
                });
                this.setState({
                    JiraStatus: jiraStatus
                });
            }
        }).catch((error) => {
            window.apiError(error);
        });
    }

    useFilters() {
        const advancedFilterContainer = document.getElementById("filtering");
        const filterCheckbox = advancedFilterContainer.querySelectorAll(`input:checked`);

        let advancedFilters = {
            Client: this.state.ClientName || null,
            Namespace: this.state.Namespace || null,
            ResolvedBy: this.state.ResolvedBy || null,
            OwnerFullName: this.state.OwnerFullName || null,
            dateFrom: this.state.dateFrom || null,
            dateTo: this.state.dateTo || null,
            ResolveddateFrom: this.state.ResolveddateFrom || null,
            ResolveddateTo: this.state.ResolveddateTo || null,
            sortByDate: this.state.sortByDate || null,
        };

        filterCheckbox.forEach(filter => {
            const filterName = filter.getAttribute("area");
            const filterValue = filter.getAttribute("value");
            const existsInAdvancedFilter = filterName in advancedFilters;

            if (!existsInAdvancedFilter) {
                advancedFilters[filterName] = filterValue;
            } else {
                advancedFilters[filterName] += `, ${filterValue}`;
            }
        });

        this.props.useFilter(advancedFilters);
    }

    handleChange(e) {
        if (e.target.name === "Namespace") {
            autocomplete(document.getElementById("namespace"), this.state.Namespaces, this);
        }
        if (e.target.type === "checkbox") {
            this.setState({
                [e.target.name]: e.target.checked
            });
        } else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    clearFilters() {
        const advancedFilterContainer = document.getElementById("filtering");
        const filterCheckboxes = advancedFilterContainer.querySelectorAll("input:checked");

        filterCheckboxes.forEach(filter => {
            filter.checked = false;
        });

        var filterInputs = advancedFilterContainer.querySelectorAll(".form-control");
        filterInputs.forEach(filter => {
            filter.value = "";
        });

        this.setState({
            filterError: "",
            dateFilter: "",
            dateFrom: "",
            dateTo: "",
            showDateFilter: false,
            clearSaleforceFilters: new Date,
            Source: []
        });

        sessionStorage.removeItem("LastFilters");
    }

    dateSelection(e, dates) {
        this.setState({
            dateFrom: moment(dates.selection.startDate).subtract(1, "days").format("YYYY-MM-DD"),
            dateTo: moment(dates.selection.endDate).add(1, "days").format("YYYY-MM-DD"),
            showCustom: false
        });
    }

    setDate(DateRange) {
        this.setState({
            dateFilter: DateRange
        });

        switch (DateRange) {
            case "Yesterday": this.setState({ dateFrom: moment().subtract(2, "days").format("YYYY-MM-DD"), dateTo: moment().format("YYYY-MM-DD") });
                break;

            case "This Week": this.setState({ dateFrom: moment().startOf("isoWeek").format("YYYY-MM-DD"), dateTo: moment().endOf("isoWeek").format("YYYY-MM-DD") });
                break;

            case "This Month": this.setState({ dateFrom: moment().startOf("Month").format("YYYY-MM-DD"), dateTo: moment().endOf("Month").format("YYYY-MM-DD") });
                break;

            case "Six Month": this.setState({ dateFrom: moment().subtract(6, "months").startOf("isoWeek").format("YYYY-MM-DD"), dateTo: moment().format("YYYY-MM-DD") });
                break;

            default: return null;
        }
    }

    ResolveddateSelection(e, dates) {
        this.setState({
            ResolveddateFrom: moment(dates.selection.startDate).subtract(1, "days").format("YYYY-MM-DD"),
            ResolveddateTo: moment(dates.selection.endDate).add(1, "days").format("YYYY-MM-DD"),
            showCustomResolve: false
        });
    }

    setResolvedDate(DateRange) {
        this.setState({
            ResolveddateFilter: DateRange
        });

        switch (DateRange) {
            case "Yesterday": this.setState({ ResolveddateFrom: moment().subtract(2, "days").format("YYYY-MM-DD"), ResolveddateTo: moment().format("YYYY-MM-DD") });
                break;

            case "This Week": this.setState({ ResolveddateFrom: moment().startOf("isoWeek").format("YYYY-MM-DD"), ResolveddateTo: moment().endOf("isoWeek").format("YYYY-MM-DD") });
                break;

            case "This Month": this.setState({ ResolveddateFrom: moment().startOf("Month").format("YYYY-MM-DD"), ResolveddateTo: moment().endOf("Month").format("YYYY-MM-DD") });
                break;

            case "Six Month": this.setState({ ResolveddateFrom: moment().subtract(6, "months").startOf("isoWeek").format("YYYY-MM-DD"), ResolveddateTo: moment().format("YYYY-MM-DD") });
                break;

            default: return null;
        }
    }

    sourceChanged(e) {
        let SourceArr = [];
        let sources = document.querySelectorAll(`[area="Source"]`);
        for (var i = 0; i < sources.length; i++) {
            if (sources[i].checked) {
                SourceArr.push(sources[i].value);
            }
        }

        this.setState({
            Source: SourceArr
        });
    }

    shouldShowFilterColumn(sourcesThatShouldShowColumn) {
        return sourcesThatShouldShowColumn.some(function (source) {
            return this.state.Source.includes(source);
        }.bind(this));
    }

    isSalesForce() {
        return this.state.Source.length === 1 && this.shouldShowFilterColumn([process.env.REACT_APP_SALESFORCE]);
    }

    render() {
        return (
            <div id="filtering">
                <p className="pl-1 mb-0" style={{ fontWeight: "bolder", fontSize: "14px", textDecoration: "underline" }}>Note: Click a source below to see more filters! Depending on your selection you will see status, severity and/or date filters</p>
                <Row>
                    <Col lg={{ span: 3 }}>
                        <span className="advanced-filter-header">Source</span>
                        <Form>
                            <Form.Check
                                custom
                                label="Salesforce Cases"
                                type="checkbox"
                                onChange={(e) => this.sourceChanged(e)}
                                area="Source"
                                value={process.env.REACT_APP_SALESFORCE}
                                id={`${process.env.REACT_APP_SALESFORCE}-999`}
                            />

                            {!this.state.Source.includes(process.env.REACT_APP_SALESFORCE) && (
                                <div>
                                    <Form.Check
                                        custom
                                        label="Salesforce SaaS KB"
                                        type="checkbox"
                                        onChange={(e) => this.sourceChanged(e)}
                                        area="Source"
                                        value={process.env.REACT_APP_SALESFORCEKB}
                                        id={`${process.env.REACT_APP_SALESFORCEKB}-999`}
                                    />
                                    {this.state.Sources.map((items, index) =>
                                        <Form.Check
                                            key={index}
                                            custom
                                            label={items}
                                            type="checkbox"
                                            onChange={(e) => this.sourceChanged(e)}
                                            area="Source"
                                            value={items}
                                            id={`${items}-${index}`}
                                        />
                                    )}
                                    <Form.Check
                                        custom
                                        label="Community Discussions"
                                        type="checkbox"
                                        onChange={(e) => this.sourceChanged(e)}
                                        area="Source"
                                        value="Communities"
                                        id="Communities-997"
                                    />
                                    <Form.Check
                                        custom
                                        label="Ceridian Salesforce Help"
                                        type="checkbox"
                                        onChange={(e) => this.sourceChanged(e)}
                                        area="Source"
                                        value={process.env.REACT_APP_SALESFORCEHELP}
                                        id={`${process.env.REACT_APP_SALESFORCEHELP}-999`}
                                    />
                                </div>
                            )}
                        </Form>
                    </Col>
                    <Col lg={{ span: 9 }}>

                        <SalesforceFilters isSalesForce={this.isSalesForce()} clearSaleforceFilters={this.state.clearSaleforceFilters} />

                        {this.state.Source.length === 1 && this.shouldShowFilterColumn(["D365"]) && (
                            <Row id="D365-filters">
                                <Col lg={{ span: 4 }}>
                                    <span className="advanced-filter-header">Area</span>
                                    <Form>
                                        {this.state.Area.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items}
                                                type={"checkbox"}
                                                area="Area"
                                                value={items}
                                                id={`${items}-${index}`}
                                            />
                                        )}
                                        <Form.Check
                                            custom
                                            label={"Professional Services"}
                                            type={"checkbox"}
                                            area="SubArea"
                                            value={"Professional Services"}
                                            id={`pro-services`}
                                        />

                                    </Form>
                                </Col>
                                <Col lg={{ span: 3 }}>
                                    <span className="advanced-filter-header">Status</span>
                                    <Form>
                                        {this.state.Status.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items.name}
                                                type={"checkbox"}
                                                area="Status"
                                                value={items.value}
                                                id={`${items.name}-${index}`}
                                            />
                                        )}
                                    </Form>
                                </Col>
                                <Col lg={{ span: 3 }}>
                                    <span className="advanced-filter-header">Severity</span>
                                    <Form>
                                        {this.state.Severity.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items.name}
                                                type={"checkbox"}
                                                area="Severity"
                                                value={items.value}
                                                id={`${items}-${index}`}
                                            />
                                        )}

                                    </Form>
                                </Col>
                            </Row>
                        )}

                        {this.state.Source.length === 1 && this.shouldShowFilterColumn(["TFS"]) && (
                            <Row id="TFS-filters">

                                <Col lg={{ span: 3 }}>
                                    <span className="advanced-filter-header">Work Item Type</span>
                                    <Form>
                                        {this.state.WorkItemType.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items}
                                                type={"checkbox"}
                                                area="WorkItemType"
                                                value={items}
                                                id={`${items}-${index}`}
                                            />
                                        )}
                                    </Form>
                                </Col>
                                <Col lg={{ span: 3 }}>
                                    <span className="advanced-filter-header">Status</span>
                                    <Form>
                                        {this.state.TFSStatus.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items}
                                                type={"checkbox"}
                                                area="TFSState"
                                                value={items}
                                                id={`${items}-${index}`}
                                            />
                                        )}
                                    </Form>
                                </Col>
                                <Col lg={{ span: 3 }}>
                                    <span className="advanced-filter-header">Severity</span>
                                    <Form>
                                        {this.state.TFSSeverity.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items}
                                                type={"checkbox"}
                                                area="Severity"
                                                value={items}
                                                id={`${items}-${index}`}
                                            />
                                        )}

                                    </Form>
                                </Col>
                            </Row>
                        )}

                        {this.state.Source.length === 1 && this.shouldShowFilterColumn(["Jira"]) && (
                            <Row id="Jira-filters">

                                <Col lg={{ span: 3 }}>
                                    <span className="advanced-filter-header">Issue Type</span>
                                    <Form>
                                        {this.state.IssueType.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items}
                                                type={"checkbox"}
                                                area="IssueType"
                                                value={items}
                                                id={`${items}-${index}`}
                                            />
                                        )}
                                    </Form>
                                </Col>
                                <Col lg={{ span: 4 }}>
                                    <span className="advanced-filter-header">Status</span>
                                    <Form>
                                        {this.state.JiraStatus.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items}
                                                type={"checkbox"}
                                                area="JiraStatus"
                                                value={items}
                                                id={`${items}-${index}`}
                                            />
                                        )}
                                    </Form>
                                </Col>
                                <Col lg={{ span: 3 }}>
                                    <span className="advanced-filter-header">Severity</span>
                                    <Form>
                                        {this.state.JiraSeverity.map((items, index) =>
                                            <Form.Check
                                                key={index}
                                                custom
                                                label={items}
                                                type={"checkbox"}
                                                area="Severity"
                                                value={items}
                                                id={`${items}-${index}`}
                                            />
                                        )}

                                    </Form>
                                </Col>
                            </Row>
                        )}
                    </Col>
                </Row>
                <small>These filters will take priority over the target in the header</small>
                <hr />
                <Row>
                    {this.state.Source.length === 1 && this.shouldShowFilterColumn(["D365", "TFS", "Jira", process.env.REACT_APP_SALESFORCE]) && (
                        <div>
                            <span className="advanced-filter-header" style={{ paddingLeft: "15px" }}>Update Date</span>
                            <Col lg={{ span: 12 }}>
                                <ButtonGroup className="mb-3" aria-label="Date buttons" data-toggle="buttons">
                                    <Button type="radio" variant="secondary" className={this.state.dateFilter === "Yesterday" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setDate("Yesterday")}>Yesterday</Button>
                                    <Button type="radio" variant="secondary" className={this.state.dateFilter === "This Week" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setDate("This Week")}>This Week</Button>
                                    <Button type="radio" variant="secondary" className={this.state.dateFilter === "This Month" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setDate("This Month")}>This Month</Button>
                                    <Button type="radio" variant="secondary" className={this.state.dateFilter === "Six Month" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setDate("Six Month")}>Six Month</Button>
                                    <Button type="radio" variant="secondary" className={this.state.dateFilter === "custom" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setState({ dateFilter: "custom", showCustom: true })}>Custom Range</Button>
                                </ButtonGroup>
                                {this.state.dateFilter !== null && (
                                    <Button variant="link" style={{ verticalAlign: "top" }} onClick={() => this.setState({ dateFilter: null, dateFrom: null, dateTo: null })}>X</Button>
                                )}
                            </Col>
                            {(this.state.dateFilter === "custom" && this.state.showCustom) && (
                                <Col lg={{ span: 12 }}>
                                    <DateRangeCalendar selection={(e, dates) => this.dateSelection(e, dates)} />
                                </Col>
                            )}
                        </div>
                    )}

                    {this.shouldShowFilterColumn(["D365", process.env.REACT_APP_SALESFORCE]) && (
                        <div>
                            <span className="advanced-filter-header" style={{ paddingLeft: "15px" }}>Completed Date</span>
                            <Col lg={{ span: 12 }}>
                                <ButtonGroup className="mb-3" aria-label="Date buttons" data-toggle="buttons">
                                    <Button type="radio" variant="secondary" className={this.state.ResolveddateFilter === "Yesterday" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setResolvedDate("Yesterday")}>Yesterday</Button>
                                    <Button type="radio" variant="secondary" className={this.state.ResolveddateFilter === "This Week" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setResolvedDate("This Week")}>This Week</Button>
                                    <Button type="radio" variant="secondary" className={this.state.ResolveddateFilter === "This Month" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setResolvedDate("This Month")}>This Month</Button>
                                    <Button type="radio" variant="secondary" className={this.state.ResolveddateFilter === "Six Month" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setResolvedDate("Six Month")}>Six Month</Button>
                                    <Button type="radio" variant="secondary" className={this.state.ResolveddateFilter === "custom" ? "date-filter-btn active" : "date-filter-btn"} onClick={() => this.setState({ ResolveddateFilter: "custom", showCustomResolve: true })}>Custom Range</Button>
                                </ButtonGroup>
                                {this.state.ResolveddateFilter !== null && (
                                    <Button variant="link" style={{ verticalAlign: "top" }} onClick={() => this.setState({ ResolveddateFilter: null, ResolveddateFrom: null, ResolveddateTo: null })}>X</Button>
                                )}
                            </Col>
                            {(this.state.ResolveddateFilter === "custom" && this.state.showCustomResolve) && (
                                <Col lg={{ span: 12 }}>
                                    <DateRangeCalendar selection={(e, dates) => this.ResolveddateSelection(e, dates)} />
                                </Col>
                            )}
                        </div>
                    )}
                </Row>
                {this.shouldShowFilterColumn(["D365", process.env.REACT_APP_SALESFORCE]) && (
                    <Row>
                        <Col lg={{ span: 12 }}>
                            <div style={{ display: "inline-block", width: "30%", marginLeft: "-10px" }}>
                                <span className="advanced-filter-header">Namespace <small>(exact match)</small></span>
                                <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                                    <div className="autocomplete">
                                        <input id="namespace" style={{ width: "100%" }} className="form-control" type="text" name="Namespace" onChange={(e) => this.handleChange(e)} />
                                    </div>
                                </form>
                            </div>
                            <div style={{ display: "inline-block", width: "30%", padding: "0px 10px" }}>
                                <span className="advanced-filter-header">Resolved By <small>(exact match)</small></span>
                                <input id="ResolvedBy" style={{ width: "100%" }} className="form-control" type="text" name="ResolvedBy" onChange={(e) => this.handleChange(e)} />
                            </div>
                            <div style={{ display: "inline-block", width: "30%", padding: "0px 10px" }}>
                                <span className="advanced-filter-header">Owner Name<small>(exact match)</small></span>
                                <input id="OwnerFullName" style={{ width: "100%" }} className="form-control" type="text" name="OwnerFullName" onChange={(e) => this.handleChange(e)} />
                            </div>
                        </Col>
                    </Row>
                )}

                <Col lg={{ span: 12 }}>
                    <div className="float-right pt-4">
                        <Form.Check custom inline label={"sort by date"} type={"checkbox"} className="sortByDate" area="Topic" name="sortByDate" id="sortByDate" onChange={(e) => this.handleChange(e)} />
                        <Button variant="link" className="clear-filters" onClick={() => this.clearFilters()}>clear filters</Button>
                        <Button className="add-filters" onClick={() => this.useFilters()}>Ok</Button>
                    </div>
                </Col>
                {this.state.filterError !== "" && (
                    <p className="filter-error">{this.state.filterError}</p>
                )}
            </div>
        );
    }
}